import { Crud, httpClient, HttpClient } from 'lib/HttpClient';

class SubscriptionSchemesApi extends Crud {
    constructor(client: HttpClient) {
        super(client, import.meta.env.API_SERVER_URL, 'subscriptionschemes');
    }
}

export const subscriptionSchemesApi = new SubscriptionSchemesApi(httpClient);
